import { useState } from 'react';
import HttpService from '../config/http/http.service';
import { endpoints } from '../constants/endpoints';
import { useAuthContext } from '../context/Auth/AuthContext';
import { Credentials } from '../interfaces/auth.interface';
import usePegaMas from './useJogos';
import { games } from '../constants/games';
import { AxiosRequestConfig } from 'axios';

let loginAbortController: AbortController;
const useLogin = () => {
    const httpService = new HttpService();
    const [succeed, setSucceed] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const { setAuthenticated } = useAuthContext();
    const { getPrizes } = usePegaMas();

    const login = async (credentials: Credentials) => {
        try {
            if (loginAbortController)
                loginAbortController.abort('Request already in progress');

            loginAbortController = new AbortController();

            const options: AxiosRequestConfig = {
                signal: loginAbortController.signal
            };

            const data = await httpService.post(endpoints.LOGIN, credentials, options);
            if (!data) return false;

            const { mainObject }: any = data;
            setAuthenticated(true, mainObject.token);
            await getPrizes(games.PEGAMAS);
            return true;
        } catch (error) {
            setError(true);
            return false;
        }
    }

    return {
        login,
        succeed,
        error
    }
};

export default useLogin;
